import { render } from "./ExpiryContent.vue?vue&type=template&id=7e77b3f8"
import script from "./ExpiryContent.vue?vue&type=script&lang=js"
export * from "./ExpiryContent.vue?vue&type=script&lang=js"
script.render = render

export default script